import { render, staticRenderFns } from "./CostModel.vue?vue&type=template&id=d2310748&scoped=true&"
import script from "./CostModel.vue?vue&type=script&lang=js&"
export * from "./CostModel.vue?vue&type=script&lang=js&"
import style0 from "./CostModel.vue?vue&type=style&index=0&id=d2310748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2310748",
  null
  
)

export default component.exports